// extracted by mini-css-extract-plugin
export default {"title":"article-title_title__Pdfuu"};